// extracted by mini-css-extract-plugin
export default {"success":"styles_success__S-IiO","error":"styles_error__roze8","warning":"styles_warning__ndAZM"};